export default __webpack_public_path__ + "static/media/trailerhelling.fd23f08f.svg";